import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["data-test"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "textbox__asterisk",
  "aria-hidden": "true"
}, "*", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "sr-only" }, "(required)", -1)
const _hoisted_4 = ["disabled", "max", "min", "placeholder", "readonly", "required"]
const _hoisted_5 = {
  key: 0,
  class: "textbox__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["textbox", { 'textbox--required': _ctx.required }]),
    "data-test": `label- ${_ctx.label}`
  }, [
    _createElementVNode("span", {
      class: _normalizeClass({ 'sr-only': _ctx.hideLabel })
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            _hoisted_3
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _withDirectives(_createElementVNode("input", {
      class: _normalizeClass(["textbox__entry", _ctx.status ? `textbox--${_ctx.status}` : null]),
      type: "time",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalInputValue) = $event)),
      disabled: _ctx.disabled,
      max: _ctx.max,
      min: _ctx.min,
      placeholder: _ctx.placeholder,
      readonly: _ctx.readonly,
      required: _ctx.required,
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
      onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 42, _hoisted_4), [
      [_vModelText, _ctx.internalInputValue]
    ]),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}